import { render } from "./status-details-popup.vue?vue&type=template&id=67d7b0aa&scoped=true"
import script from "./status-details-popup.vue?vue&type=script&lang=js"
export * from "./status-details-popup.vue?vue&type=script&lang=js"

import "./status-details-popup.vue?vue&type=style&index=0&id=67d7b0aa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d7b0aa"]])

export default __exports__